import { useAtom } from 'jotai/react';
import { viewersAtom } from '@view-model/models/sticky/viewers/viewersAtom';
import type { Viewer } from '@view-model/Viewer/Viewer';

export const useViewers = (): Viewer[] => {
  const [viewers] = useAtom(viewersAtom);
  return viewers;
};
